import { Ref, computed, ref, watch } from '@vue/composition-api'
import { ChromaKey } from '../classes'
import { debounce } from 'lodash'
import store from '@/store'
import { useCurrentTeam } from '@/modules/teams/compositions'
import { isEqual } from 'lodash'
import { useCasterStream } from '@/modules/casters/compositions'

const useChromaKey = (casterId: Ref<string>) => {
  const { teamId } = useCurrentTeam()
  const { casterStream } = useCasterStream(casterId)
  const currentChromaKey = ref(new ChromaKey(store.state.team.currentTeam[casterId.value]?.chromakey))
  const userProfileChromaKey = computed(() => new ChromaKey(store.state.team.currentTeam[casterId.value]?.chromakey))
  const hasProfile = computed(() => !!store.state.team.currentTeam[casterId.value])
  const isChromaKeyPickerMode = ref(false)

  const isChromaKeyPickerModeDisabled = computed(() => casterStream.value === null || !casterStream.value.srcObject)

  watch(userProfileChromaKey, (newVal) => {
    if (newVal === null) return
    if (isEqual(newVal, currentChromaKey.value)) return
    currentChromaKey.value = newVal
  }, { immediate: true, deep: true })

  const updateChromaKey = debounce(async () => {
    try {
      if (teamId === null) throw new Error('No teamId')
      await store.dispatch.team.updateTeamMember({
        teamId: teamId.value ?? '',
        member: { user_id: casterId.value, chromakey: currentChromaKey.value }
      })
    } catch (error) {
      console.error('Update chromakey failed', { user: casterId.value, error, chromakey: currentChromaKey.value })
    }
  }, 400)

  async function setChromaKey<K extends keyof ChromaKey, V extends ChromaKey[K]> (key: K, value: V) {
    isChromaKeyPickerMode.value = false
    currentChromaKey.value[key] = value
    await updateChromaKey()
  }

  return {
    casterStream,
    currentChromaKey,
    hasProfile,
    isChromaKeyPickerMode,
    isChromaKeyPickerModeDisabled,
    setChromaKey
  }
}

export default useChromaKey
